export const TRACK_ITEM_ICON = "icons"; // default
export const TRACK_ITEM_PHOTO = "photos";
export const TRACK_ITEM_ICON_SET = "icon-set";
export const TRACK_ITEM_CREATIVE = "creative"; // creative pro sub only

export const TRACK_PURCHASE_PRO_YEAR = "pro_year";
export const TRACK_PURCHASE_PRO_MONTH = "pro_month";
export const TRACK_PURCHASE_CPRO = "creative_pro_year";
export const TRACK_PURCHASE_ALC = "purchase_alc";
export const TRACK_CANCELLATION = "subscription_canceled";

export const TRACK_PAYG_FREE_TRIAL = "payg_free_trial";

export const TRACK_USER_CHECKOUT = "user"; // default
export const TRACK_TEAM_CHECKOUT = "team";
export const TRACK_EDU_CHECKOUT = "edu";

export const TRACK_SIGN_UP = "signup";
export const TRACK_SIGN_IN = "login";

export const TRACK_DOWNLOAD_ICON = "download_icon";
export const TRACK_DOWNLOAD_ICON_SET = "download_icon_set";
export const TRACK_DOWNLOAD_PHOTO = "download_photo";

export const TRACK_FIGMA_DOWNLOAD = "download_figma_clicked";

export const TRACK_QV_OPEN = "quick_view_open";
export const TRACK_QV_NEXT = "quick_view_next";

export const TRACK_EMPTY_SEARCH = "view_empty_search";
export const TRACK_EMPTY_FILTER_SEARCH = "view_empty_filtered_search";
export const TRACK_ICON_FILTER = "icon_filter";

export const TRACK_ICON_MATCH_OPEN = "icon_match_open";

export const TRACK_PHOTO_ROYALTY_PDF = "photo_royalty_pdf";

export const TRACK_AD_CLICK = "squarespace_click";

// Generic event tracking
export const trackEvent = (eventName, params = {}) => {
    if (!window?.dataLayer || !eventName || typeof eventName !== "string") {
        return;
    }

    window.dataLayer.push({
        event: eventName,
        ...params,
    });
};

// Track when user's load a detail page
export const trackViewItem = ({ itemType = TRACK_ITEM_ICON, itemId, itemName }) => {
    if (!window.dataLayer) return;

    window.dataLayer.push({
        event: "view_item",
        ecommerce: {
            currency: "USD",
            items: [
                {
                    item_id: itemId,
                    item_name: itemName,
                    item_category: itemType,
                },
            ],
        },
    });
};

// Track when user's open the purchase-options drawer
export const trackViewPurchaseOptions = ({
    itemType = TRACK_ITEM_ICON,
    itemId,
    itemName,
}) => {
    if (!window.dataLayer) return;

    window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            currency: "USD",
            items: [
                {
                    item_id: itemId,
                    item_name: itemName,
                    item_category: itemType,
                },
            ],
        },
    });
};

// Track when users load a checkout page
export const trackViewCheckout = ({
    itemType = TRACK_ITEM_ICON,
    itemId,
    itemName,
    purchaseType,
    userType = TRACK_USER_CHECKOUT,
    price = "0.00",
}) => {
    if (!window.dataLayer) return;

    window.dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
            currency: "USD",
            value: price,
            items: [
                {
                    item_id: itemId || `${itemType}_${purchaseType}`,
                    item_name: itemName || "Subscription",
                    // icon|photo > pro_year|pro_month|purchase_alc > user|team|edu
                    item_category: itemType,
                    item_category2: purchaseType,
                    item_category3: userType,
                    price,
                },
            ],
        },
    });
};

// Track when a successful purchase is made.
export const trackPurchase = ({
    itemType = TRACK_ITEM_ICON,
    itemId,
    itemName,
    purchaseType,
    userType = TRACK_USER_CHECKOUT,
    price = "0.00",
}) => {
    if (!window.dataLayer) return;

    window.dataLayer.push({
        event: "purchase",
        conversionValue: price,
        ecommerce: {
            currency: "USD",
            value: price,
            items: [
                {
                    item_id: itemId || `${itemType}_${purchaseType}`,
                    item_name: itemName || "Subscription",
                    item_category: itemType,
                    item_category2: purchaseType,
                    item_category3: userType,
                    price,
                },
            ],
        },
    });
};

// Track when quick-view modal is opened
export const trackQuickView = ({ isOpening = false }) =>
    trackEvent(isOpening ? TRACK_QV_OPEN : TRACK_QV_NEXT);

// Track asset download
export const trackIconDownload = (params = { source: "web" }) =>
    trackEvent(TRACK_DOWNLOAD_ICON, params);
export const trackIconSetDownload = () => trackEvent(TRACK_DOWNLOAD_ICON_SET);
export const trackPhotoDownload = () => trackEvent(TRACK_DOWNLOAD_PHOTO);

/*---------------------------
| Header
---------------------------*/
const TRACK_HEADER_PRICING_CLICKED = "header_pricing_clicked";
const TRACK_HEADER_LOGIN_CLICKED = "header_login_clicked";
const TRACK_HEADER_TOOLS_CLICKED = "header_tools_clicked";
const TRACK_HEADER_ACCOUNT_AVATAR_CLICKED = "header_account_avatar_clicked";
const TRACK_HEADER_BELL_CLICKED = "header_bell_clicked";
const TRACK_HEADER_MARKETING_CLICKED = "header_marketing_clicked";
const TRACK_HEADER_PROMO_CLICKED = "header_promo_clicked";
const TRACK_HEADER_PROMO_CTA_CLICKED = "header_promo_cta_clicked";
const TRACK_HEADER_FIGMA_CLICKED = "header_figma_clicked";

// Link
export const trackHeaderPricingClicked = () => {
    trackEvent(TRACK_HEADER_PRICING_CLICKED);
};
// Button
export const trackHeaderLoginClicked = () => {
    trackEvent(TRACK_HEADER_LOGIN_CLICKED);
};
// Button: Track only on open of Tools drop down
export const trackheaderToolsClicked = () => {
    trackEvent(TRACK_HEADER_TOOLS_CLICKED);
};
// Button
export const trackheaderAccountAvatarClicked = () => {
    trackEvent(TRACK_HEADER_ACCOUNT_AVATAR_CLICKED);
};
// Button
export const trackheaderBellClicked = () => {
    trackEvent(TRACK_HEADER_BELL_CLICKED);
};
// Button: Technically this is a block that contains a hyperlink dangerouslySetInnerHTML
export const trackheaderMarketingClicked = () => {
    trackEvent(TRACK_HEADER_MARKETING_CLICKED);
};
// Button
export const trackHeaderPromoClicked = () => {
    trackEvent(TRACK_HEADER_PROMO_CLICKED);
};
// Link:
export const trackHeaderPromoCtaClicked = () => {
    trackEvent(TRACK_HEADER_PROMO_CTA_CLICKED);
};
export const trackHeaderFigmaClicked = () => trackEvent(TRACK_HEADER_FIGMA_CLICKED);
